module.exports = __webpack_public_path__ + "img/flag-AR.4df415cf.png";